import React from 'react';
import { cn } from '../lib/utils';

interface CenteredColumnProps {
  children: React.ReactNode;
  maxWidth?: number | string;
  sidePadding?: number;
  backgroundColor?: string;
  className?: string;
}

export function CenteredColumn({ 
  children, 
  maxWidth, 
  sidePadding, 
  backgroundColor,
  className 
}: CenteredColumnProps) {
  const maxWidthValue = maxWidth 
    ? (typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth)
    : undefined;

  return (
    <div className="w-full">
      <div 
        className={cn(
          "mx-auto",
          className
        )}
        style={{
          maxWidth: maxWidthValue,
          backgroundColor: backgroundColor || 'transparent',
          paddingLeft: sidePadding ? `${sidePadding}px` : undefined,
          paddingRight: sidePadding ? `${sidePadding}px` : undefined,
        }}
      >
        {children}
      </div>
    </div>
  );
}


